<template>
  <!-- custom-form-type cft -->
  <div>
    <FormItem label="领域类别：">
      <div class="cft">
        <Select v-model="type" style="width:200px" @on-change="change">
          <Option v-for="item in typeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </div>
    </FormItem>
    <FormItem>
      <div class="cft">
        <!-- <div>{{JSON.stringify(formValue)}}</div> -->
        <customFormBrand v-if="selectMode === 0" @change="changeValue" :field="formValue"></customFormBrand>
        <customFormFactory v-if="selectMode === 1" @change="changeValue" :field="formValue"></customFormFactory>
        <customFormAlliance v-if="selectMode === 2" @change="changeValue" :field="formValue"></customFormAlliance>
        <customFormImport v-if="selectMode === 3" @change="changeValue" :field="formValue"></customFormImport>
        <customFormCommerce v-if="selectMode === 4" @change="changeValue" :field="formValue"></customFormCommerce>
        <customFormGroup v-if="selectMode === 5" @change="changeValue" :field="formValue"></customFormGroup>
        <customFormService v-if="selectMode === 6" @change="changeValue" :field="formValue"></customFormService>
        <customFormMore v-if="selectMode === 7" @change="changeValue" :field="formValue"></customFormMore>
      </div>
    </FormItem>
  </div>
</template>

<script>
import customFormBrand from "@/components/customForm/custom-form-brand/custom-form-brand.vue"; // 品牌商
import customFormFactory from "@/components/customForm/custom-form-factory/custom-form-factory.vue"; // 工厂
import customFormMore from "@/components/customForm/custom-form-more/custom-form-more.vue"; // 更多
import customFormImport from "@/components/customForm/custom-form-import/custom-form-import.vue"; // 进口商
import customFormCommerce from "@/components/customForm/custom-form-commerce/custom-form-commerce.vue"; // 微电商
import customFormGroup from "@/components/customForm/custom-form-group/custom-form-group.vue"; // 综合集团
import customFormService from "@/components/customForm/custom-form-service/custom-form-service.vue"; // 服务商
import customFormAlliance from "@/components/customForm/custom-form-alliance/custom-form-alliance.vue"; // 加盟商
import { mapGetters } from "vuex";
export default {
  // 企业信息修改
  name: "custom-form-type",
  props: {
    formData: {
      type: Object,
      default: { extend: [], properties: [] }
    }
  },
  model: {
    prop: "formData",
    event: "sendFormData"
  },
  data() {
    return {
      refArr: [
        "customFormBrand",
        "customFormFactory",
        "customFormAlliance",
        "customFormImport",
        "customFormCommerce",
        "customFormGroup",
        "customFormService",
        "customFormMore"
      ],
      typeList: [
        {
          value: "品牌商",
          label: "品牌商",
          busMode: 0
        },
        {
          value: "工厂",
          label: "工厂",
          busMode: 1
        },
        {
          value: "加盟商",
          label: "加盟商",
          busMode: 2
        },
        {
          value: "进口商",
          label: "进口商",
          busMode: 3
        },
        {
          value: "微电商",
          label: "微电商",
          busMode: 4
        },
        {
          value: "综合集团",
          label: "综合集团",
          busMode: 5
        },
        {
          value: "服务商",
          label: "服务商",
          busMode: 6
        },
        {
          value: "更多",
          label: "更多",
          busMode: 7
        }
      ],
      type: "进口商",
      selectMode: 0,
      factoryModel: null,
      formValue: { extend: [], properties: [], busMode: this.selectMode }
    };
  },
  components: {
    customFormBrand,
    customFormFactory,
    customFormMore,
    customFormImport,
    customFormCommerce,
    customFormGroup,
    customFormService,
    customFormAlliance
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany"
    }),
    busMode() {
      return this.company ? this.company.busMode : 0;
    }
  },
  created() {
    this.formValue = Object.assign({}, this.formData, {busMode: this.selectMode});  
    this.selectMode = this.busMode;
    this.setType(); 
  },
  methods: {
    init() {
      if (this.company.extend) {
        this.formValue.extend = JSON.parse(this.company.extend);
      }
      if (this.company.properties) {
        this.formValue.properties = JSON.parse(this.company.properties);
      }
    },
    change(e) {
      if (e) {
        this.typeList.forEach(c => {
          if (c.label === e) {
            this.selectMode = c.busMode;
          }
        });
        this.formValue.busMode = this.selectMode;
        this.init();
        this.$emit("sendFormData", this.formValue);
      }
    },
    setType() {
      this.typeList.forEach(c => {
        if (c.busMode === this.busMode) {
          this.type = c.label;
        }
      });
    },
    changeValue(val) { 
      this.formValue = val;
      this.formValue.busMode = this.selectMode; 
      this.$emit("sendFormData", this.formValue);
    }
  }
};
</script>

<style scoped lang="scss">
</style>
